import React from 'react';
import { UserModel } from '../../../models/UserModel';
import avatar from '../../../image/avatar.png';

interface UserHeaderProps {
  localUser: UserModel;
  primaryColor: string;
}

const UserHeader: React.FC<UserHeaderProps> = ({ localUser, primaryColor }) => {
  return (
    <div className="text-center detail-user-header" style={{ marginTop: '20px' }}>
      <img
        src={
          localUser.profile_picture
            ? `${process.env.REACT_APP_API_BASE}/${localUser.profile_picture}`
            : avatar
        }
        alt="User Avatar"
        className="shadow"
        style={{
          margin: '0 auto',
          width: '200px',
          height: '200px',
          objectFit: 'cover',
          borderRadius: '50%',
          border: `3px solid ${primaryColor}`,
        }}
      />
      <h4 className="mt-2 fw-bold" style={{ color: primaryColor }}>
        {localUser.firstname} {localUser.name}
      </h4>
      <p className="text-muted">{localUser.email}</p>
    </div>
  );
};

export default UserHeader;